import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, IconButton, Toolbar, Typography } from '@material-ui/core';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import FormularioApp from 'app/Core/Components/Formulario/FormularioApp';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import XAPPButton from '../../Core/Components/Button/XAPPButton';
import * as Actions from './Store/Actions/EmpresaPessoaFolgaActions';

const md = new MobileDetect(window.navigator.userAgent);

const newFolgaState = {
    idpessoaformulario: null,
    idpessoa: null,
    idparent: null,
    tipo: 134,
    formulario: {},
    requeridos: null,
};

class EmpresaPessoaFolgaDialog extends XAPPComponent {

    state = {
        ...newFolgaState,
        idpessoa: this.props.xappRouteParams.empresa,
        idparent: this.props.idparent,
    };

    componentDidUpdate(prevProps, prevState) {
        const { xappRouteParams } = this.props;

        if (this.props.EmpresaPessoaFolga.error) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaFolga.error,
                variant: 'error'
            });
            this.props.EmpresaPessoaFolga.error = null;
        }
        if (this.props.EmpresaPessoaFolga.warning) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaFolga.warning,
                variant: 'warning'
            });
            this.props.EmpresaPessoaFolga.warning = null;
        }
        if (this.props.EmpresaPessoaFolga.info) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaFolga.info,
                variant: 'success'
            });
            this.props.EmpresaPessoaFolga.info = null;
            if (!_.isNull(this.props.EmpresaPessoaFolga.id) && this.state.idpessoaformulario === null) {
                this.setState({ idpessoaformulario: this.props.EmpresaPessoaFolga.id });
            }
        }

        if (_.isNull(prevProps.open) && !_.isNull(this.props.open)) {
            if (!_.isNull(this.props.open.idpessoaformulario)) {
                this.setState(this.props.open);
            }
            else {
                this.setState({
                    ...newFolgaState,
                    idpessoa: this.props.xappRouteParams.empresa,
                    idparent: this.props.idparent,
                });
            }
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    handleChangeFormulario = (_AForm) => {
        this.setState({ "formulario": _AForm });
    }

    setRequeridos = (_ARequeridos) => {
        this.setState(_.set({ ...this.state }, "requeridos", _ARequeridos));
    }

    canBeSubmitted = () => {
        const { requeridos, formulario } = this.state;
        if ((Object.keys(formulario).length < 1) || (requeridos === null)) {
            return false;
        }
        var AResponse = true;
        Object.keys(requeridos).forEach(key => {
            if (AResponse && requeridos[key] &&
                (_.isUndefined(formulario[key]) || _.isNull(formulario[key]) || formulario[key].length < 1)) {
                AResponse = false;
            }
        });

        return AResponse;
    }

    render() {
        const { idparent, save, xappRouteParams, template, acaoRegistro, open, openDialog } = this.props;
        const form = this.state;
        return (
            <XAPPDialog
                id="EmpresaPessoaFolga"
                open={open}
                onClose={() => openDialog(null)}
                fullWidth
                fullScreen={md.mobile() !== null}
                maxWidth={md.mobile() === null && md.tablet() === null && "md"}
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {!_.isNull(open) && !_.isNull(open.idpessoaformulario) ? "Editar dia de folga" : "Novo dia de folga"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent className="p-0">
                    <div className="p-24">
                        {template !== undefined && template !== null &&
                            <FormularioApp
                                Formulario={template}
                                onChange={this.handleChangeFormulario}
                                customProps={[]}
                                setRequeridos={this.setRequeridos}
                                data={form.formulario}
                                xappRouteParams={xappRouteParams}
                            />
                        }
                    </div>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white mr-8"
                                variant="contained"
                                color="primary"
                                onClick={() => save(form, xappRouteParams, idparent)}
                                disabled={!this.canBeSubmitted()}
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={"save"}
                                label={md.mobile() === null && md.tablet() === null ? 'Salvar' : ''}
                            />
                            {form.idpessoaformulario !== null &&
                                <XAPPButton
                                    type="Button"
                                    className="bg-grey-darker hover:bg-grey-darker text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        acaoRegistro(form, xappRouteParams, form.statusregistro === 0 ? 'ATIVAR' : 'INATIVAR', idparent);
                                        openDialog(null);
                                    }}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"block"}
                                    label={md.mobile() === null && md.tablet() === null ? (form.statusregistro === 0 ? 'Ativar' : 'Inativar') : ''}
                                />
                            }
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
        acaoRegistro: Actions.acaoRegistro,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaPessoaFolga }) {
    return {
        template: EmpresaPessoaFolga.template,
        EmpresaPessoaFolga: EmpresaPessoaFolga
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaFolgaDialog);
